export default () => ({
  state: {
    pageNumber: 0,
    pageSize: 0,
    succeeded: null,
    totalPages: 0,
    totalRecords: 0,
    sort: new Map(),
    filters: new Map(),
  },
  getters: {
    getMeta: (state) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords,
    }),
    getFilters: (state) =>
      [...state.filters].map(([key, value]) => ({
        key,
        value,
      })),
    pageNumber: (state) => state.pageNumber,
    pageSize: (state) => state.pageSize,
    succeeded: (state) => state.succeeded,
    totalPages: (state) => state.totalPages,
    totalRecords: (state) => state.totalRecords,
    queryString: (state) => {
      if (state.sort.size === 0 && state.filters.size === 0) return ''

      let filters = Array.from(state.filters)
      filters = filters
        .map((f) => {
          const key = f[0]
          const value = f[1]
          if (typeof value === 'string' || typeof value === 'number') return `${key}=${value}`
          if (Array.isArray(value)) return `${key}=${value.join(',')}`
        })
        .join('&')

      const sort = Array.from(state.sort)
        .map((f) => `sort=${f[0]} ${f[1]}`)
        .join()
      return `?${sort}&${filters}`
    },
  },
  mutations: {
    CLEAR_FILTERS(state) {
      state.filters = new Map()
    },
    ADD_FILTER(state, { key, value }) {
      state.filters.set(key, value)
      const filters = Array.from(state.filters).filter(([_, value]) => !!value)
      state.filters = new Map(filters)
    },
    SET_SORT(state, sort) {
      state.sort = new Map()
      state.sort.set(sort.key, sort.value)
    },
    SET_META_DATA(state, { pageNumber, pageSize, succeeded, totalPages, totalRecords }) {
      state.pageNumber = pageNumber
      state.pageSize = pageSize
      state.succeeded = succeeded
      state.totalPages = totalPages
      state.totalRecords = totalRecords
    },
  },
})
